import { UseFormReturn } from 'react-hook-form';
import type { Tag } from 'react-tag-input';
import { EditorPickFormValues } from './editorPick.schema';
import { addTagToList } from './tags.utils';

export function useTagHandler(form: UseFormReturn<EditorPickFormValues>) {
  return (item: { id: number; label: string; value: string }) => {
    const current = (form.getValues('tags') as Tag[] | undefined) ?? [];
    const next = addTagToList(current, item);
    if (next !== current) {
      form.setValue('tags', next, { shouldDirty: true, shouldValidate: true });
    }
  };
}
